import type { Feature } from "./registry";
import { eventsFeature } from "./events";
import { walletDebugFeature } from "./walletDebug";
import { platformFeature } from "./platform";
import { economyFeature } from "./economy";
import { marketFeature } from "./market";
import { hapticsFeature } from "./haptics";
import { achievementsFeature } from "./achievements";
import { almanacFeature } from "./almanac";
import { cosmeticsFeature } from "./cosmetics";
import { guideFeature } from "./guide";
import { dealsFeature } from "./deals";
import { shopsFeature } from "./shops";
import { modesFeature } from "./modes";
import { forgeFeature } from "./forge";
import { researchFeature } from "./research";
import { cardsFeature } from "./cards";
import { seasonFeature } from "./season";
import { dailyRoadFeature } from "./dailyRoad";
import { eventModesFeature } from "./eventModes";
import { suppliesFeature } from "./supplies";
import { offerTriggersFeature } from "./offerTriggers";
import { recordsFeature } from "./records";
import { challengesFeature } from "./challenges";
import { trophyHallFeature } from "./trophyHall";
import { petsFeature } from "./pets";
import { analyticsFeature } from "./analytics";
import { rewardFlyFeature } from "./rewardFly";

/**
 * Every feature the game installs, in registration order (which breaks ties in the registry's `order`). Append-only:
 * each package adds its one line here (FINISH_PLAN §3: main.ts, hubView.ts and saves.ts stay frozen).
 */
export const FEATURES: readonly Feature[] = [
  eventsFeature,
  walletDebugFeature,
  platformFeature,
  economyFeature,
  marketFeature,
  hapticsFeature,
  achievementsFeature,
  almanacFeature,
  cosmeticsFeature,
  guideFeature,
  dealsFeature,
  shopsFeature,
  modesFeature,
  forgeFeature,
  researchFeature,
  cardsFeature,
  seasonFeature,
  dailyRoadFeature,
  eventModesFeature,
  suppliesFeature,
  offerTriggersFeature,
  recordsFeature,
  challengesFeature,
  trophyHallFeature,
  petsFeature,          // after suppliesFeature: it chains the supplies' prepareRun
  analyticsFeature,
  rewardFlyFeature,     // last: its first holdings snapshot needs every feature's state attached (cosmetics' skins)
];
